export const GUIDE_CATEGORY_OPTIONS = [
  "General",
  "EUV Gen3/Gen3+",
  "EUV Gen2/Gen2+",
  "EUVGen4 Tumalo",
  "EUVHalo Mk1",
  "H2D",
  "Proteus",
  "HRS",
  "IT",
  "HR",
  "Finance",
] as const;

export const GUIDE_SOURCE_TYPES = ["paste", "upload", "url"] as const;
export const GUIDE_STATUSES = ["approved", "archived"] as const;
export const GUIDE_VISIBILITIES = ["public", "internal"] as const;

export interface Guide {
  id: string;
  title: string;
  category: string;
  content: string;
  author: string;
  created_at: string;
  updated_at: string;
  format?: "markdown" | "static-html";
  readonly?: boolean;
  view_count?: number;
  source_type: string;
  source_url?: string;
  summary?: string;
  status: string;
  read_time: number;
  visibility: string;
  archived_at?: string;
}

export interface GuideListQuery {
  category?: string;
  search?: string;
  source_type?: string;
  status?: string;
  visibility?: string;
}

export interface GuideCreateInput {
  id?: string;
  title: string;
  category: string;
  content: string;
  author: string;
  format?: "markdown" | "static-html";
  source_type?: string;
  source_url?: string;
  summary?: string;
  visibility?: string;
}

export interface GuideUpdateInput {
  title?: string;
  category?: string;
  content?: string;
  author?: string;
  format?: "markdown" | "static-html";
  source_type?: string;
  source_url?: string;
  summary?: string;
  status?: string;
  read_time?: number;
  visibility?: string;
}

export interface SearchResult {
  guides: Guide[];
  total: number;
}
